export const sortByString = <T>(data: T[], key, asc): T[] => {
  return data.sort((a, b) => {
    if (asc) {
      return (a[key] || '').toLowerCase().localeCompare(b[key]?.toLowerCase() || '');
    } else {
      return (b[key] || '').toLowerCase().localeCompare(a[key]?.toLowerCase() || '');
    }
  });
};
